import {
  RecordProps,
  TLBaseShape,
  TLDrawShapeSegment,
  TLPageId,
  vecModelValidator,
} from "tldraw"
import { T } from "@tldraw/validate"
import { Transform } from "./StickerShape"
import { Color, Expr } from "./Expr"

export type Orientation = {
  x: number
  y: number
  rotation: number
  segments: TLDrawShapeSegment[]
}

export type CloneOptions = {
  num: Expr<number>
  transformation: Transform
}

export type VisibilityAndOpacity = {
  visible: Expr<boolean>
  opacity: Expr<number>
}

export type CustomDrawShapeProps = {
  isFill: boolean
  segments: TLDrawShapeSegment[]
  isComplete: boolean
  isPen: boolean
  scale: number
  layer: string
  baseOrientation?: Orientation
  transform: Transform
  clone?: CloneOptions
  isClone?: boolean
} & (
  | {
      isFill: false
      parameterValues: VisibilityAndOpacity & {
        strokeColor: Expr<Color>
        strokeWidth: Expr<number>
      }
    }
  | {
      isFill: true
      parameterValues: VisibilityAndOpacity & {
        fillColor: Expr<Color>
      }
    }
)

export type CustomDrawShape = Omit<
  TLBaseShape<"custom-draw", CustomDrawShapeProps>,
  "meta"
> & { meta: {} }

/** @public */
export const DrawShapeSegment: T.ObjectValidator<TLDrawShapeSegment> = T.object(
  {
    type: T.literalEnum("free", "straight"),
    points: T.arrayOf(vecModelValidator),
  },
)

/** @public */
export const customDrawShapeProps: RecordProps<CustomDrawShape> = {
  isFill: T.boolean,
  segments: T.arrayOf(DrawShapeSegment),
  isComplete: T.boolean,
  isPen: T.boolean,
  scale: T.nonZeroNumber,
  layer: T.string,
  baseOrientation: T.any,
  transform: T.any,
  clone: T.any,
  isClone: T.any,
  parameterValues: T.any,
}
